// CMS pages are served under a language segment — https://www.<cmsUrl>/<language>/<path>.
// Every layout used to concatenate that URL inline and half of them left the segment out,
// so a Chinese client opening Education or a promotion landed on the English page. All CMS
// links resolve through here instead, and `cmsUrl` itself is written by _preload on login.

export const getCmsLanguage = () => localStorage?.getItem("language") || "en";

const isFullUrl = (value) => /^https?:\/\//i.test(String(value || ""));

export const getCmsHost = () => localStorage?.getItem("cmsUrl") || null;

// path: the CMS route without the language segment ("educational", item.urlPath, …).
// host: defaults to the stored cmsUrl; pass the brand website when that is the origin.
// prefix: subdomain to prepend when the host is a bare domain ("www." unless stated).
export const buildCmsUrl = (path = "", {host = getCmsHost(), prefix = "www."} = {}) => {
    if (isFullUrl(path)) return path;
    if (!host) return null;

    const origin = (/^https?:\/\//i.test(host) ? host : "https://" + prefix + host).replace(/\/+$/, "");
    const language = getCmsLanguage();
    const segment = String(path ?? "").trim().replace(/^\/+|\/+$/g, "");

    // The section API already returns urlPath with the language in front ("en/basic-001"),
    // and the CMS answers a doubled prefix ("/en/en/basic-001") with a 404 — so a path that
    // opens with any locale-looking segment is passed through untouched.
    if (/^[a-z]{2}(-[a-z]{2,4})?(\/|$)/i.test(segment)) return origin + "/" + segment;

    return [origin, language, segment].filter(Boolean).join("/");
};
